module.exports = __webpack_public_path__ + "i18n/pt-BR.6b1069963a6a6c51961016cfc0b14f12.json";